var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#02d__02d__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#02d__02d__b)",
    fillRule: "evenodd",
    d: "M79.698 37.47L85.4 29.5l-16.7 1.8 1.7-16.8-13.6 9.9L50 9l-6.8 15.4-13.7-9.9 1.8 16.7-16.8-1.7 9.9 13.6L9 50l15.4 6.8-9.9 13.7 16.7-1.8-1.7 16.8 13.6-9.9L50 91l6.8-15.4 13.7 9.8-1.35-12.524H53.466c-3.222 0-6.258-1.177-8.55-3.408-2.417-2.292-3.718-5.39-3.78-8.737v-.123c0-3.16 1.24-6.135 3.47-8.365a12.25 12.25 0 018.117-3.718c1.673-2.417 4.461-3.842 7.497-3.842h.682C64.248 39.974 69.762 37 75.649 37c1.384 0 2.741.163 4.05.47z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD348",
    fillRule: "evenodd",
    d: "M60.178 72.876c-11.59 5.094-25.43.788-31.894-10.367-6.802-11.909-2.701-27.32 9.202-34.224 11.991-6.798 27.276-2.71 34.188 9.17a18.36 18.36 0 00-10.772 7.228h-.682c-3.036 0-5.824 1.425-7.497 3.842a12.25 12.25 0 00-8.117 3.718 11.765 11.765 0 00-3.47 8.365v.123c.062 3.346 1.363 6.445 3.78 8.737 2.292 2.23 5.328 3.408 8.55 3.408h6.712z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#02d__02d__c)",
    fillRule: "evenodd",
    d: "M46.356 70.665C40.454 69.61 35.027 66.058 31.8 60.493c-5.798-9.998-2.3-22.895 7.699-28.694 9.774-5.669 22.32-2.45 28.294 7.038a18.394 18.394 0 00-6.89 5.846h-.682c-3.036 0-5.824 1.425-7.497 3.842a12.25 12.25 0 00-8.117 3.718 11.766 11.766 0 00-3.47 8.365v.123c.062 3.346 1.363 6.445 3.78 8.737.452.44.934.84 1.44 1.197z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#DDD",
    fillRule: "evenodd",
    d: "M90.272 52.428c-1.177-7.001-7.374-12.33-14.623-12.33-5.639 0-10.72 3.16-13.198 8.117a5.715 5.715 0 00-2.23-.434c-2.603 0-4.834 1.55-5.701 3.842-.372-.062-.682-.062-1.054-.062-2.54 0-4.895.992-6.63 2.788-1.672 1.735-2.602 3.966-2.602 6.32v.124c.062 2.54 1.053 4.833 2.85 6.506 1.673 1.673 3.966 2.603 6.382 2.603H87.98c4.895 0 8.923-3.966 8.923-8.86 0-4.09-2.788-7.622-6.63-8.614z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#02d__02d__d)",
    fillRule: "evenodd",
    d: "M90.272 52.428c-1.177-7.001-7.374-12.33-14.623-12.33-5.639 0-10.72 3.16-13.198 8.117a5.715 5.715 0 00-2.23-.434c-2.603 0-4.834 1.55-5.701 3.842-.372-.062-.682-.062-1.054-.062-2.54 0-4.895.992-6.63 2.788-1.672 1.735-2.602 3.966-2.602 6.32v.124c.062 2.54 1.053 4.833 2.85 6.506 1.673 1.673 3.966 2.603 6.382 2.603H87.98c4.895 0 8.923-3.966 8.923-8.86 0-4.09-2.788-7.622-6.63-8.614z",
    clipRule: "evenodd",
    opacity: 0.6,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#02d__02d__e)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#B6B6B6",
    d: "M58.176 65.503c1.107 0 15.396-.789 16.407-1.24 1.382-.616-1.481-4.32 0-4.628.669-.139 1.652-.575 1.652-.575s2.698-.992 3.163-.992c.465 0 .232-1.837.086-2.98l-.086-.819c0-.539-1.606-1.657-1.86-3.017-.175-.947.263-2.221.172-2.459 0 0-.032-.017-.023-.02.01-.002.017.005.023.02.07.033.571.203.571.203 1.207.409 3.116 1.078 4.834 2.256 1.028.704 2.442 2.053 2.442 2.053s1.02.788 1.276 1.045c.62.62 2.478 2.478 3.718 2.478h3.098l1.394.985.31 1.99c0 4.895-4.028 8.86-8.923 8.86H51.36s2.788-3.16 6.816-3.16z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "02d__02d__c",
    x1: 36.496,
    x2: 63.495,
    y1: 33.908,
    y2: 66.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAF22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#F09900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "02d__02d__d",
    x1: 69.329,
    x2: 70.568,
    y1: 49.702,
    y2: 69.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B2B2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "02d__02d__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(41 0 0 41 50 50)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.514,
    stopColor: "#D6B849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652,
    stopColor: "#FFCE47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB73"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "02d__02d__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h100v100H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "02d__02d__e",
    width: 52.668,
    height: 28.565,
    x: 47.022,
    y: 44.435,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_149_1382",
    stdDeviation: 2.169
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFair);
export default __webpack_public_path__ + "static/media/fair.6aca75599aab9cff82edc22b81f66cb5.svg";
export { ForwardRef as ReactComponent };